// utils/date.ts
export const formatToDateInput = (dateStr: string | number | undefined | null): string => {
// 1. まず文字列に変換する (null/undefinedなら空文字に)
  const str = String(dateStr || '');

  // 2. 文字列として長さをチェック
  if (str.length !== 8) return ''; 

  // 3. 切り出し
  return `${str.substring(0, 4)}-${str.substring(4, 6)}-${str.substring(6, 8)}`;
};

export const formatFromDateInput = (dateStr: string): string => {
  return dateStr.replace(/-/g, '');
};

// 今日の日付を "yyyyMMdd" 形式で返す
export const getTodayYyyyMmDd = (): string => {
  const today = new Date();
  const isoDate = today.toISOString().split('T')[0]; // "yyyy-MM-dd"
  return formatFromDateInput(isoDate); // "yyyyMMdd"
};

// 日時フォーマットヘルパー関数を定義
// APIから来るISO文字列 (UTC) を日本のロケールでミリ秒まで表示
export const formatBidTimestamp = (timestamp: string | Date): string => {
  if (!timestamp) return 'N/A';
  try {
    const date = new Date(timestamp);
    // 'ja-JP'ロケールで、ミリ秒(fractionalSecondDigits: 3)まで表示
    return date.toLocaleString('ja-JP', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      fractionalSecondDigits: 3,
      hour12: false // 24時間表記
    });
  } catch (error) {
    // 予期せぬ形式の場合
    return String(timestamp); 
  }
};

// UTCをJSTに変換
export const formatUtcToJst = (utcDateStr: string | Date | null | undefined): string => {
  if (!utcDateStr) return '';
  
  try {
    let date: Date;

    if (typeof utcDateStr === 'string') {
      // "2026-03-26 05:21:50.9811708" のような形式を安全にパースするための正規化
      // 1. スペースを 'T' に置換(Safariなどでのパースエラー対策)
      let normalizedStr = utcDateStr.trim().replace(' ', 'T');
      
      // 2. 末尾にタイムゾーン指定('Z' や '+09:00')が無ければ 'Z' (UTC) を強制付与
      if (!normalizedStr.endsWith('Z') && !normalizedStr.includes('+') && !normalizedStr.match(/-\d{2}:\d{2}$/)) {
        normalizedStr += 'Z';
      }
      
      date = new Date(normalizedStr);
    } else {
      date = new Date(utcDateStr);
    }

    // 無効な日付(Invalid Date)の場合は、元の文字列をそのまま返す
    if (isNaN(date.getTime())) return String(utcDateStr);

    // 日本時間 (Asia/Tokyo) を明示してフォーマット
    // 出力例: "2026/03/26 14:21:50"
    const formatter = new Intl.DateTimeFormat('ja-JP', {
      timeZone: 'Asia/Tokyo',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });

    return formatter.format(date);

  } catch (error) {
    return String(utcDateStr);
  }
};